(function () {
  function initCtsSection(root) {
    var slider = root.querySelector('[data-cts-slider]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-cts-tile]'));
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-cts-nav-link]'));
    var prevBtn = root.querySelector('[data-cts-prev]');
    var nextBtn = root.querySelector('[data-cts-next]');

    if (!slider || !tiles.length || !navLinks.length) return;

    var isProgrammaticScroll = false;
    var scrollEndTimer = null;

    function setActive(index) {
      navLinks.forEach(function (link) {
        var isActive = parseInt(link.getAttribute('data-index'), 10) === index;
        link.classList.toggle('is-active', isActive);
      });
      tiles.forEach(function (tile) {
        var isActive = parseInt(tile.getAttribute('data-index'), 10) === index;
        tile.classList.toggle('is-active', isActive);
      });
    }

    function scrollToTile(index) {
      var tile = tiles[index];
      if (!tile) return;
      isProgrammaticScroll = true;
      slider.scrollTo({
        left: tile.offsetLeft - slider.offsetLeft,
        behavior: 'smooth'
      });
    }

    slider.addEventListener('scroll', function () {
      if (!isProgrammaticScroll) return;
      if (scrollEndTimer) clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function () {
        isProgrammaticScroll = false;
      }, 120);
    });

    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        var index = parseInt(link.getAttribute('data-index'), 10);
        setActive(index);
        scrollToTile(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.scrollBy({ left: -slider.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (isProgrammaticScroll) return;
          var mostVisible = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!mostVisible || entry.intersectionRatio > mostVisible.intersectionRatio) {
                mostVisible = entry;
              }
            }
          });
          if (mostVisible) {
            var index = parseInt(mostVisible.target.getAttribute('data-index'), 10);
            setActive(index);
          }
        },
        {
          root: slider,
          threshold: [0.5, 0.75, 1]
        }
      );

      tiles.forEach(function (tile) {
        observer.observe(tile);
      });
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-cts-section]');
    sections.forEach(initCtsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-cts-section]');
    if (section) initCtsSection(section);
  });
})();
